import React, { useEffect, useState } from 'react'
import {
    getBookingForm
} from '../hooks/booking'
import { useParams } from 'react-router-dom'

export default function WhiteListFailed() {
    let [event, setEvent] = useState(null)
    const params = useParams()
    const { id } = params

    const getBookingFormData = async () => {
        try {
            const response = await getBookingForm(id)
            console.log(response)
            setEvent(response.data.mapRoute)
        } catch (error) {

        }
    }

    useEffect(() => { }, [event])

    useEffect(() => {
        getBookingFormData()
        // eslint-disable-next-line 
    }, [])

    if (event)
        return (
            <div className='container'>
                <br /><br />
                <center>
                    <h1>{event.name}</h1>
                    <hr />
                    {event && event.whiteListText && <div>
                        <h3>{event.whiteListText}</h3>
                    </div>}
                </center>
            </div>
        )
    else return (<div></div>)
}
